import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { FormattedMessage, FormattedDate } from 'react-intl';
import momentTz from 'moment-timezone';
import { Check } from 'shared-components/icons';
import moment from 'moment';

export class BlockDayProcessedModal extends React.Component {

  constructor (props) {
    super(props);
    this.momentifyDate = this.momentifyDate.bind(this);
  }

  componentDidMount () {
    const { bookingId = '', reason = '' } = this.props;
    analyticsIntegrations.declineConfirmation(bookingId, reason);
  }

  momentifyDate (dateTime, timeZoneId = 'America/Los_Angeles') {
    const { date, time } = dateTime;
    // uses global moment function
    const momentDateTime = momentTz.tz(`${date.y}-${date.m}-${date.d} ${time.h}:${time.m}`, 'YYYY-MM-DD HH:mm', timeZoneId);
    return momentDateTime;
  }

  render () {
    const { booking = {}, onClose } = this.props;
    const { schedule = [] } = booking;
    const spaceId = booking.space_id;
    const formattedSchedule = schedule.map(({ start, end }, i) => {
      const startDateTime = this.momentifyDate(start);
      const endDateTime = this.momentifyDate(end);
      const startTime = startDateTime.format('h:mm a');
      const endTime = endDateTime.format('h:mm a');
      const formattedStartTime = this.props.intl.formatTime(moment(startTime, 'LT').format());
      const formattedEndTime = this.props.intl.formatTime(moment(endTime, 'LT').format());
      return (<div className="strike-through heavier" key={i}>
        <FormattedDate
          value={this.momentifyDate(start)}
          year="numeric"
          month="short"
          day="numeric"
          timeZone={'America/Los_Angeles'}
        /> {formattedStartTime} - {formattedEndTime}
      </div>);
    });
    return (
      <BootstrapModal
        onClose={onClose}
        modalClass="block-day-processed-modal"
        showModal
        bannerClass="no-padding"
        banner={{
          type: 'success',
          text:
            <p className='paddng-xl-left padding-xl-right padding-md-top padding-md-bottom'>
              <div className="flex center middle"><Check height="20px" width="20px" className="margin-md-right" />
                <div className="text-small"><FormattedMessage
                  id="inbox.block_day_notification_modal.booking_request_declined.modal_banner"
                  defaultMessage="Booking request declined"
                /></div>
              </div>
            </p>
        }}
        headerClass="no-top-padding no-bottom-padding"
        header={
          <div>
            <h3>
              <FormattedMessage
                id="inbox.block_day_notification_modal.booking_request_declined.title.calendar_updated"
                defaultMessage="Calendar updated"
              />
            </h3>
            <p>
              <FormattedMessage
                id="inbox.block_day_notification_modal.booking_request_declined.copy.calendar_updated"
                defaultMessage="Your calendar has been updated to mark this time as unavailable."
              />
            </p>
          </div>
        }
        bodyClass="padding-no-top padding-no-bottom"
        body={
          <div className="text-center padding-xl-top padding-xl-bottom blockday-modalbody">
            <p className="datetime-label heavier text-small" style={{ marginBottom: '12px' }}>
              <FormattedMessage
                id="inbox.block_day_notification_modal.booking_request_declined.date_time_unavailable"
                defaultMessage="Date and time unavailable"
              />
            </p>
            {formattedSchedule.slice(0,3).map((schedule, i) => (
              <p key={i} className="no-margin text-gray-dark blockday-date-time">{schedule}</p>)) }
            {3 < formattedSchedule.length && <p className="text-small text-gray-dark" style={{ marginTop: '12px' }}>
              <FormattedMessage
                id="inbox.block_day_notification_modal.booking_request_declined.more_day"
                defaultMessage="+{days} more {dayLabel}"
                values={{ days: formattedSchedule.length - 3,
                  dayLabel: 1 === formattedSchedule.length - 3
                    ? <FormattedMessage
                      id="inbox.block_day_notification_modal.booking_request_declined.day_label"
                      defaultMessage= 'day'
                    />
                    : <FormattedMessage
                      id="inbox.block_day_notification_modal.booking_request_declined.days_label"
                      defaultMessage= 'days'
                    /> }}
              />
            </p>}
          </div>
        }
        footer={
          <div>
            <a href={`/calendar/${spaceId}`} className="btn btn-block btn-primary classic">
              <FormattedMessage
                id="inbox.block_day_notification_modal.booking_request_declined.btn_text"
                defaultMessage="View on calendar"
              />
            </a>
            <a href={`/calendar/${spaceId}/settings`} className="btn btn-block underline">
              <FormattedMessage
                id="inbox.block_day_notification_modal.booking_request_declined.calendar_sync_settings"
                defaultMessage="Calendar sync settings"
              />
            </a>
          </div>
        }
        modalSize="sm-size"
      />
    );
  }
}

BlockDayProcessedModal.propTypes = {
  onClose: PropTypes.func,
  schedule: PropTypes.array,
  bookingId: PropTypes.string,
  reason: PropTypes.string,
  spaceId: PropTypes.string,
  syncConnected: PropTypes.bool
};
